import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { auth } from "../../../utils/auth";
import { formatCurrency, formatNumber } from "../../../utils/helpers";
import { request } from "../../../utils/request";

const PrintItemsReorden = () => {
	const [items, setItems] = useState([]);
	const [listo, setListo] = useState(false);

	const getItems = async () => {
		const searchString = window.location.search.includes("?")
			? window.location.search + "&tipo=item&orderBySuplidor=true"
			: "?tipo=item&orderBySuplidor=true";
		const response = await request(`items${searchString}`);

		if (response.data) {
			setItems(response.data);
			setListo(true);
		}
	};

	useEffect(() => {
		getItems();
	}, []);

	// Espera a que el estado con los datos ya esté reflejado en el DOM
	// antes de abrir el diálogo de impresión.
	useEffect(() => {
		if (listo) {
			window.print();
		}
	}, [listo]);

	const user = auth.getUser();
	const sucursal = user.sucursales.filter(
		(suc) => suc.id === user.sucursalActual
	)[0];

	const valorTotal = items.reduce((acc, item) => {
		if (!item.costo) {
			return acc;
		}
		return (
			acc + (item.costo * (item.impuesto?.porcentaje + 1))
		);
	}, 0);
	return (
		<>
			<div className="row">
				<h2 className="col-md-12 text-center m-b-5">Reporte Reorden Interno</h2>
				<div className="col-md-12 text-center">
					{sucursal.nombre} - {sucursal.direccion} •{" "}
					{dayjs().format("DD/MM/YYYY")}
				</div>
				<div className="col-md-12 text-right p-b-10">
					<div className="float-left">
						TOTAL PRODUCTOS: {items.length}
					</div>

					<div className="float-right">
						<h3>VALOR TOTAL: {formatCurrency(valorTotal)}</h3>
					</div>
				</div>
			</div>
			<table className="table m-b-40">
				<thead>
					<tr>
						<th>Producto</th>
						<th>Referencia</th>
						<th>Cantidad</th>
						<th>Reorden</th>
						<th>Costo</th>
						<th className="text-right">Suplidor</th>
						<th className="text-right">Teléfono</th>
					</tr>
				</thead>
				<tbody>
					{items.map((item) => {
						return (
							<tr key={item.id}>
								<td>{item.nombre}</td>
								<td>{item.referencia}</td>
								<td>
									{isNaN(parseFloat(item.cantidad))
										? "-"
										: formatNumber(item.cantidad)}
								</td>
								<td>
									{isNaN(parseFloat(item.reorden))
										? "-"
										: formatNumber(item.reorden)}
								</td>
								<td>{formatCurrency(item.costo * (item.impuesto?.porcentaje + 1), "$")}</td>
								<td className="text-right">
									{item.suplidor?.nombre}
								</td>
								<td className="text-right">
									{item.suplidor?.telefono}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			<div className="row">
				<div className="col-md-12 text-right p-b-10">
					<div className="float-left">
						TOTAL PRODUCTOS: {items.length}
					</div>

					<div className="float-right">
						<h3>VALOR TOTAL: {formatCurrency(valorTotal)}</h3>
					</div>
				</div>
			</div>
		</>
	);
};

export default PrintItemsReorden;
